import {INuveiCardFieldModel} from "./nuvei-card-field.view-model.interface";
import {IServiceFactory} from "../../../../../../../service-factory.interface";
import {NullableString} from "../../../../../../../../types/nullable-types";
import {makeObservable, observable, runInAction} from "mobx";

interface INuveiCardFieldError {
    id: string;
    message: string;
}
interface INuveiCardFieldChangeEvent {
    field: SafeCharge.FieldType;
    cardType: string;
    empty: boolean;
    complete: boolean;
    paste: boolean;
    scanned: boolean;
    allFieldsCompleted: boolean;
    error?: INuveiCardFieldError;
}

export const UNSUPPORTED_NUVEI_CARD_TYPES: string[] = [
    'amex', 'uatp'
];

export class NuveiCardFieldModel implements  INuveiCardFieldModel {
    constructor(public readonly fieldType: SafeCharge.FieldType,
                public readonly safeChargeField: SafeCharge.Field,
                private readonly services: IServiceFactory) {
        this.safeChargeField.on('change', this._onChange);
        makeObservable<this, '_isErrorsValidationActive'>(this, {
            _isErrorsValidationActive: observable.ref
        })
    }

    private _onChange = (event: INuveiCardFieldChangeEvent) => {
        if(event.field === this.fieldType) {
            runInAction(() => {
                this._lastChangeEvent = event;
                this._isErrorsValidationActive = false;
            });
        }
    }

    private get cardType(): "visa" | "mastercard" | 'diners' | 'discover' | string | null  {
        return this._lastChangeEvent?.cardType?.toLowerCase() ?? null;
    }

    private _lastChangeEvent: INuveiCardFieldChangeEvent | null = null;
    private _isErrorsValidationActive = false;

    get isErrorsValidationActive(): boolean {
        return this._isErrorsValidationActive;
    }

    attach(element: HTMLElement) {
        this.safeChargeField.attach(element);
    }

    focus(): void {
        this.safeChargeField.focus();
    }


    activateValidationErrors(): void {
        runInAction(() => {
            this._isErrorsValidationActive = true;
        })
    }


    get errorMessage(): NullableString {
        if(!this.isErrorsValidationActive) {
            return null;
        }


        if(!this._lastChangeEvent) {
            return this.services.language.translate("Required field");
        }

        if(this._lastChangeEvent.empty) {
            return this.services.language.translate("Required field");
        }

        if(this.fieldType === 'ccNumber' && this.cardType && UNSUPPORTED_NUVEI_CARD_TYPES.includes(this.cardType.toLowerCase())) {
            return this.services.language.translationFor('{cardType} is not supported').withParams({
                cardType: this.cardType.toUpperCase()
            });
        }

        if(!this._lastChangeEvent.error) {
            return null;
        }

        switch (this._lastChangeEvent.error.id) {
            case "incomplete_card_number":
                return this.services.language.translate("Incomplete card number");
            case "incorrect_card_number":
                return this.services.language.translate("Incorrect card number");
            case "incomplete_date":
                return this.services.language.translate("Incomplete expiration date");
            case "date_in_past":
                return this.services.language.translate("Expiration date is in the past");
            case "invalid_expiration_year":
                return this.services.language.translate("Invalid expiration year");
            case "incomplete_cvc":
                return this.services.language.translate("Incomplete CVV");
            default:
                return this._lastChangeEvent.error.message;

        }

    }






}